<template>
  <div class="flex justify-center w-full p-10">
    <div class>
      <h2 class="text-gray-900 py-4 text-xl">Bestellbestätigung</h2>
      <div class="border p-4">
        <!--Check div  -->
        <div class="flex py-2">
          <div class="text-3xl p-1 text-center content-center rounded-full">
            <i class="fa fa-check text-teal-400"></i>
          </div>
          <div class="pl-4 w-full">
            <p class="text-2xl">VIELEN DANK!</p>
            <p class="text-sm">Deine Bestellung ist bei uns eingegangen.</p>
          </div>
          <div class="text-right float-right w-full">
            <router-link
              to="/"
              class="border border-gray-400 rounded p1 shadow hover:text-gray-800"
            >Weiter einkaufen</router-link>
          </div>
        </div>
        <!-- /Check div -->
        <!-- Gift div -->
        <!-- <div class="flex py-2">
          <div class="text-3xl p-1 text-center content-center block rounded-full">
            <i class="fa fa-gift text-teal-400"></i>
          </div>
          <div class="pl-4 w-full">
            <p class="text-2xl">1 KLEINES GESCHENK WARTET AUF DICH!</p>
            <p class="text-sm">Deine Bestellung ist bei uns eingegangen.</p>
          </div>
          <div class="text-right float-right w-full">
            <router-link
              to
              class="border border-gray-400 rounded p1 shadow hover:text-gray-800"
            >Gutschein ausw</router-link>
          </div>
          
        </div> -->
        <!-- /Gift div-->
        <!-- Description div -->
        <div class>
          <div class="py-6">
            <hr />
          </div>
          <!-- <p>Deine Bestellnummer lautet:</p> -->
          <div class="text-center">
            <button @click="getOrderReviewPDF" class="bg-teal-400 px-4 py-1 text-white">Klicken Sie hier, um die Auftragsbestätigung im PDF-Format zu erhalten</button>
          </div>
          <p
            class="py-4"
          >In den natechen Minuten erhaltst du eine E-Mail mit einer Zusammenfassung deine Bestellung.</p>
          <p class="py-4">
            Sollest du keine E-Mail erhalten, überprüfe bitte deine Spam-Ordner.Sofern du nach 24 Stunden immer
            <br />noch keine E-Mail erhalten hast, wende dich bitte an unseren Kundenservice.
          </p>
        </div>
        <!-- /Description div -->
        <!-- Footer div -->
        <div>
          <div class="py-6">
            <p>
              Viele Grüße
              <br />dein Team von Homeface.
            </p>
          </div>
        </div>
        <!-- /Footer div -->
      </div>
      <div class="flex py-4">
        <router-link
          to="/"
          class="bg-teal-400 text-white p-1 mb-1 hover:bg-white hover:text-teal-400"
        >Zurück zum Shop</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      order_id: this.$route.query.id
    };
  },
  created() {
    this.sendOrderEmail();
  },
  methods: {

    sendOrderEmail(){
       axios
        .post(`${process.env.VUE_APP_API}/orderemail`, {
          order_id: this.order_id,
        })
        .then(() => {  })

    },

    redirect() {
      this.$router.push("/");
    },
    getOrderReviewPDF() {
      window.open(`https://api.homeface.de/order-pdf/${this.order_id}`);
      // window.open(`https://api.homeface.de/order-pdf/${this.order_id}`);
    }
  }
};
</script>

<style>
</style>